let attemptNo = 0;
const maxAttempts = 10;

export default function retrieveUserDataRepeated(dispatch) {
	console.info("dispatch", dispatch);
	return dispatch('RETRIEVE_USER_DATA')
		.then(() => {
			console.log('RETRIEVE_USER_DATA then');
			attemptNo = 0;
		})
		.catch((err) => {
			console.log('RETRIEVE_USER_DATA catch');

			if (attemptNo < maxAttempts) {
				attemptNo++;

				console.info("attemptNo", attemptNo);
				return retrieveUserDataRepeated(dispatch);
			}

			return dispatch('RETRIEVE_USER');

			/*return dispatch('LOGOUT').then(() => {
				throw {
					global: 'Sorry, Something Went Wrong. Please contact support for assistance.'
				};
			});*/
		});
}
